var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in", appear: "" } },
    [
      _c(
        "router-link",
        {
          staticClass: "c-residence",
          class: _vm.css,
          attrs: {
            id: _vm.residence.slug,
            to: _vm.route,
            tabindex: "0",
            itemscope: "",
            itemtype: "http://schema.org/Product",
          },
          nativeOn: {
            mouseover: function ($event) {
              $event.stopPropagation()
              return _vm.toggleFocus(true)
            },
            mouseout: function ($event) {
              $event.stopPropagation()
              return _vm.toggleFocus(false)
            },
            focus: function ($event) {
              $event.stopPropagation()
              return _vm.toggleFocus(true)
            },
            focusout: function ($event) {
              $event.stopPropagation()
              return _vm.toggleFocus(false)
            },
          },
        },
        [
          _vm.showBanner
            ? _c("p", { staticClass: "c-residence__banner" }, [
                _vm._v("\n      Solgt\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.listType === "cards"
            ? [
                _vm.residence.hasImages === true
                  ? [
                      _vm.residence.images.length > 0
                        ? _c("card-image", {
                            attrs: {
                              id: _vm.residence.images[0].id,
                              image: _vm.residence.images[0],
                              itemprop: "image",
                            },
                          })
                        : _c("spinner", {
                            staticClass: "c-spinner c-spinner--card",
                          }),
                    ]
                  : _c("MissingImage"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("header", { staticClass: "c-residence__header" }, [
            _c(
              "h2",
              { staticClass: "c-residence__name", attrs: { itemprop: "name" } },
              [_vm._v("\n        " + _vm._s(_vm.residence.name) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "c-residence__price",
                attrs: {
                  itemprop: "offers",
                  itemscope: "",
                  itemtype: "http://schema.org/Offer",
                },
              },
              [
                _c("link", {
                  attrs: {
                    itemprop: "itemCondition",
                    href: "http://schema.org/NewCondition",
                  },
                }),
                _vm._v("\n        " + _vm._s(_vm.priceInfo) + "\n        "),
                _c("span", {
                  attrs: {
                    itemprop: "availability",
                    content: "https://schema.org/InStock",
                  },
                }),
                _vm._v(" "),
                _c("span", {
                  attrs: {
                    itemprop: "price",
                    content: _vm.residence.totalPrice,
                  },
                }),
                _vm._v(" "),
                _c("span", {
                  attrs: { itemprop: "priceCurrency", content: "NOK" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.type || _vm.bedrooms || _vm.size
            ? _c("ul", { staticClass: "c-residence__facts" }, [
                _vm.type
                  ? _c("li", { staticClass: "c-residence__fact" }, [
                      _vm._v("\n        " + _vm._s(_vm.type) + "\n      "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bedrooms
                  ? _c("li", { staticClass: "c-residence__fact" }, [
                      _vm._v("\n        " + _vm._s(_vm.bedrooms) + "\n      "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.size
                  ? _c("li", { staticClass: "c-residence__fact" }, [
                      _vm._v("\n        " + _vm._s(_vm.size) + "\n      "),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }